import { atomWithStorage } from 'jotai/utils';

export const inventoryContractListAtom = atomWithStorage<{ id: number; name: string }[]>(
  'inventory-contract-list',
  [],
);
